<template lang="html">
	<div id="app" class="main column no-header">
		<div class="background-login"></div>
		<div class="login forgot-password reset-password active">
			<div class="top" v-if="isValidToken">
				<h2>Réinitialiser le mot de passe</h2>
				<div class="label">
					Veuillez saisir un nouveau mot de passe
				</div>
			</div>
			<div class="bottom" v-if="!isValidToken">
			<p class="text-center">
			Pour des raisons de sécurité la réinitialisation de votre mot passe est valable 24h00.<br>
			Merci de bien vouloir demander à nouveau la réinitialisation de votre mot de passe.
			</p>

			<div class="ctn-connect">
					<div class="btn btn-red" @click="$router.push({ name: 'ResetPasswordEmailAsk' })">
						Réinitialisation mon mot de passe
					</div>
				</div>

			</div>
			<div class="bottom" v-else>
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('nouveau mot de passe')}">
						<label for="nouveau mot de passe">Nouveau mot de passe</label>
						<input v-validate="'required'" type="password" name="nouveau mot de passe" v-model="password" @change="errorsame=false">
					</div>
					<div v-if="errors.has('nouveau mot de passe')" class="error-message">{{ errors.first('nouveau mot de passe') }}</div>
				</div>
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('confirmation du mot de passe')}" v-on:keyup.enter="send">
						<label for="confirmation du mot de passe">Confirmation du mot de passe</label>
						<input v-validate="'required'" type="password" name="confirmation du mot de passe" v-model="passwordConfirm" @change="errorsame=false">
					</div>
					<div v-if="errors.has('confirmation du mot de passe')" class="error-message">{{ errors.first('confirmation du mot de passe') }}</div>
					<div v-if="errorsame" class="error-message">Les mots de passe doivent correspondre</div>
				</div>
				<div class="ctn-connect">
					<div class="btn btn-red" @click="send">
						Valider
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import emma from '@/common/services/Emma'
export default {
	data () {
		return {
			password: null,
			passwordConfirm: null,
			token: null,
			errorsame: null,
			isValidToken: true
		}
	},
	mounted () {
		this.token = this.$route.params.token
		this.checkValidToken()
	},
	methods: {
		checkValidToken () {
			this.$store.commit('LOADER_IN')
			emma.get('api/resetting/check/' + this.token).then((result) => {
				this.$store.commit('LOADER_OUT')
				this.isValidToken = result.data.success
			}).catch(() => {
				this.$store.commit('LOADER_OUT')
				this.isValidToken = false
			})
		},
		send () {
			if (this.password === this.passwordConfirm && this.password !== '') {
				let data = new FormData()
				data.append('plain_password[first]', this.password)
				data.append('plain_password[second]', this.passwordConfirm)
				emma.post('api/resetting/reset/' + this.token, data).then((result) => {
					if (result.data.success) {
						this.$notify({
							type: 'success',
							group: 'default',
							title: 'Le mot de passe a été correctement réinitialisé',
							text: 'Vous pouvez vous connecter avec votre nouveau mot de passe'
						})
						this.$router.push({ name: 'Login' })
					} else {
						this.$notify({
							type: 'error',
							group: 'default',
							title: 'Le mot de passe n\'a pas pu être réinitialisé',
							text: 'Le token a expiré'
						})
					}
				}).catch((error) => {
					console.warn(error)
					this.$notify({
						type: 'error',
						group: 'default',
						title: 'Une erreur est survenue',
						text: 'Veuillez réessayer'
					})
				})
			} else {
				this.errorsame = true
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.top {
	.label {
		margin: auto;
		text-align: center;
	}
}
.bottom {
	width: 500px;

	.form-elem-container {
		margin-bottom: 2rem;

		.error-message {
			width: 100%;
			text-align: center;
		}
	}

	.ctn-input.ctn-label {
		max-width: 300px;
	}

	.btn-red {
		width: 300px;
	}
}
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?3e7a561c